import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core);

const endpoints = {
    get: '/dashboard/v2/event-wizard/{id}/step/get/features/',
    update: '/dashboard/v2/event-wizard/{id}/step/update/features/',
    configurableRoles: '/dashboard/api/v3/collaborators/limits/configurable-roles/',
    configurableRolesByPicaService: '/dashboard/api/v3/collaborators/limits/configurable-roles/by-pica-service/{id}/',
};

export default {
    /**
     * Fetch features configuration for a PicaService
     * Returns only features the user has permission to configure
     */
    async fetchFeatures(picaServiceId) {
        const url = endpoints.get.replace('{id}', picaServiceId);
        return await client.get(url);
    },

    /**
     * Update features configuration
     * @param {number} picaServiceId
     * @param {Object} features - Object with feature configurations
     *   e.g., { photographer_pick: { enabled: true } }
     */
    async updateFeatures(picaServiceId, features) {
        const url = endpoints.update.replace('{id}', picaServiceId);
        return await client.post(url, features);
    },

    /**
     * Enable a feature
     * @param {number} picaServiceId
     * @param {string} featureKey - The feature key (e.g., 'photographer_pick')
     */
    async enableFeature(picaServiceId, featureKey) {
        return await this.updateFeatures(picaServiceId, {
            [featureKey]: { enabled: true }
        });
    },

    /**
     * Disable a feature
     * @param {number} picaServiceId
     * @param {string} featureKey - The feature key
     */
    async disableFeature(picaServiceId, featureKey) {
        return await this.updateFeatures(picaServiceId, {
            [featureKey]: { enabled: false }
        });
    },

    /**
     * Fetch configurable roles for collaborator limits
     * Returns roles with a code that can be used in limits configuration
     */
    async fetchConfigurableRoles(picaServiceId) {
        const url = picaServiceId
            ? endpoints.configurableRolesByPicaService.replace('{id}', picaServiceId)
            : endpoints.configurableRoles;
        const response = await client.get(url);
        return response?.roles || [];
    }
};
